export const calculateAge = (
    birthDate: Date | string,
    startDate: Date | string
): number => {

    const parsedBirthDate =
        typeof birthDate === "string"
            ? new Date(birthDate)
            : birthDate;

    const parsedStartDate =
        typeof startDate === "string"
            ? toStartOfDay(new Date(startDate))
            : toStartOfDay(startDate);

    // Guard against empty / sentinel / invalid birth dates. Empty dates now arrive from the
    // server as null (both date converters emit null for the -infinity sentinel), but a
    // caller may still hand us a manufactured year-1 "0001-01-01" sentinel or an unparseable
    // value. Without this, getFullYear() on such a date yields an absurd age ≈ the start year.
    if (!parsedBirthDate || isNaN(parsedBirthDate.getTime()) || parsedBirthDate.getFullYear() <= 1) {
        return 0;
    }

    let age = parsedStartDate.getFullYear() - parsedBirthDate.getFullYear();

    const hasHadBirthdayThisYear =
        parsedStartDate.getMonth() > parsedBirthDate.getMonth() ||
        (parsedStartDate.getMonth() === parsedBirthDate.getMonth() &&
            parsedStartDate.getDate() >= parsedBirthDate.getDate());

    if (!hasHadBirthdayThisYear) {
        age--;
    }

    return age;
};

    const toStartOfDay = (date: Date): Date => {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    }